// Trilingual Language Configuration
// Supports: Azerbaijani (az), Russian (ru), English (en)

export const translations = {
  az: {
    // Navigation
    nav: {
      home: "Ana Səhifə",
      about: "Haqqımızda",
      services: "Xidmətlər",
      gallery: "Qalereya",
      reviews: "Rəylər",
      contact: "Əlaqə",
      menu: "Menyu",
      scrollDown: "Aşağı sürüşdürün",
      bookNow: "Vaxt Təyin Et",
    },

    // Hero
    hero: {
      caption: "Premium Bərbər · Bakı, Azərbaycan",
      headline1: "Dəqiqlik. Stil.",
      headline2: "Premium Baxım.",
      subheadline: "Orkhan Babayev — hər kəsimdə dəqiqlik, hər müştəriyə xüsusi yanaşma.",
      servicesBtn: "Xidmətlərimiz",
      tagline: "Hər detalda hiss olunan premium bərbər təcrübəsi.",
    },

    // About
    about: {
      sectionTitle: "Haqqımızda",
      name: "Orkhan Babayev",
      subtitle: "Bərbərlik Sənəti",
      description: `Bakıda premium bərbər sənətinin öndə gedən simalarından olan Orkhan Babayev, hər müştəriyə fərdi yanaşma tətbiq edir. Dəqiq "fade" texnikası, klassik üsluba hörmət və detallara xüsusi diqqət — onun işinin əsasını təşkil edir. Burada hər kəsim sadəcə iş deyil, bir sənət əsəridir.`,
      highlights: [
        { title: "Dəqiq Fade Mütəxəssisi", subtitle: "Precision Fade Specialist" },
        { title: "Modern və Klassik Üslublar", subtitle: "Modern & Classic Styles" },
        { title: "Hər Detalda Mükəmməllik", subtitle: "Excellence in Every Detail" },
      ],
    },

    // Services
    services: {
      sectionTitle: "Xidmətlər",
      headline: "Hər Stil Üçün Premium Xidmət",
      bookNow: "Vaxt Təyin Et",
      items: [
        {
          name: "Saç Kəsimi",
          description: "Klassik və modern saç kəsimləri",
          price: "40-50 AZN",
        },
        {
          name: "Saç Rənglənməsi",
          description: "Peşəkar saç boyama",
          price: "60-100 AZN",
        },
        {
          name: "Saç Düzümü",
          description: "Saçın formaya salınması",
          price: "30-50 AZN",
        },
        {
          name: "Oynalıqla Qırxılma",
          description: "Ənənəvi peşəkar qırxılma (Straight razor)",
          price: "35 AZN",
        },
        {
          name: "Maşınla Saç Düzəlişi",
          description: "Saç kənarlarının və xətlərinin dəqiqləşdirilməsi",
          price: "10-15 AZN",
        },
        {
          name: "Saqqal Baxımı (Maşınla)",
          description: "Saqqalın peşəkar formada kəsilməsi və xüsusi baxım",
          price: "25-35 AZN",
        },
        {
          name: "Üz Maskası",
          description: "Üz dərisinə xüsusi baxım",
          price: "15-30 AZN",
        },
        {
          name: "Gil Maskası",
          description: "Dərin təmizləyici gil maskası",
          price: "15-30 AZN",
        },
        {
          name: "Manikür",
          description: "Səliqəli dırnaq baxımı",
          price: "40 AZN",
        },
        {
          name: "Pediqür",
          description: "Peşəkar ayaq dırnağı baxımı",
          price: "80-100 AZN",
        },
      ],
    },

    // Why Choose
    whyChoose: {
      sectionTitle: "Niyə Orkhan Babayev?",
      headline: "Sənətkarlıq. Dəqiqlik. Güvən.",
      features: [
        {
          title: "Hər Detalda Dəqiqlik",
          description: "Hər kəsim ölçülür, hər xətt mükəmməl çəkilir. Heç bir detal diqqətdən kənarda qalmır.",
        },
        {
          title: "Təmiz, Modern Üslub",
          description: "Klassik texnika ilə müasir trendlərin mükəmməl vəhdəti.",
        },
        {
          title: "Fərdi Yanaşma",
          description: "Hər müştərin üz quruluşuna və şəxsi üslubuna uyğun kəsim.",
        },
        {
          title: "Dəyişməz Keyfiyyət",
          description: "Hər gəlişinizdə eyni yüksək standart və eyni məmnuniyyət.",
        },
      ],
    },

    // Gallery
    gallery: {
      sectionTitle: "Qalereya",
      headline: "İşlərimiz",
      filters: {
        all: "Hamısı",
        fade: "Fade",
        beard: "Saqqal",
        classic: "Klassik",
        modern: "Modern",
      },
      altTexts: [
        "Pompadour fade kəsimi",
        "Fade və saqqal kombinasiyası",
        "Klassik saç kəsimi",
        "Peşəkar saqqal baxımı",
        "Dəqiq fade xətti",
        "Teksturalı saç kəsimi",
        "Modern pompadour stili",
        "Geri daranmış klassik stil (Slick back)",
        "Təmiz fade profili",
        "Orkhan Babayev iş başında",
        "Səliqəli fade keçidi",
        "Yan profildən kəsim",
      ],
    },

    // Testimonials
    testimonials: {
      sectionTitle: "Müştəri Rəyləri",
      headline: "Onlar Nə Deyir?",
      reviews: [
        {
          text: "İndiyə qədər etdirdiyim ən təmiz fade kəsimidir. Detallara olan diqqət inanılmazdır.",
          name: "Rəşad K.",
        },
        {
          text: "Peşəkar, diqqətli və hər dəfə eyni yüksək keyfiyyət. Artıq başqa ustaya getmirəm.",
          name: "Elnur M.",
        },
        {
          text: "Buradakı xidmət əsl premium təcrübədir. Sadəcə saç kəsimi deyil, xüsusi bir yanaşmadır.",
          name: "Tural N.",
        },
        {
          text: "Saqqal baxımı əladır — mükəmməl forma və dəqiq kəsim.",
          name: "Farid H.",
        },
        {
          text: "Bakıda tanıdığım ən yaxşı bərbər. Hər dəfə buradan tam razı ayrılıram.",
          name: "Kamran A.",
        },
      ],
    },

    // Contact
    contact: {
      sectionTitle: "Əlaqə",
      headline: "Randevu Al",
      note: "Əvvəlcədən vaxt yazdırılması tövsiyə olunur.",
      labels: {
        phone: "Telefon",
        address: "Ünvan",
        hours: "İş Saatları",
        instagram: "Instagram",
      },
      values: {
        phone: "+994 55 552 50 01",
        address: "Baku Marriott Hotel Boulevard, Khagani Rustamov Street, 4C, Khatai District, Baku 1010, Azerbaijan",
        hours: "Bazar ertəsi – Şənbə: 10:00 – 20:00",
        instagram: "@orkhan__babayev",
      },
      ctaCard: {
        title: "Premium Bərbər Xidməti",
        headline: "Hazırsınız?",
        description: "Yeni imicinizin vaxtıdır. Randevu alaraq Orkhan Babayevlə premium bərbər təcrübəsini yaşayın.",
        whatsapp: "WhatsApp ilə Əlaqə",
        phone: "+994 55 552 50 01",
      },
    },

    // Footer
    footer: {
      tagline: "Hər kəsim bir sənət əsəridir.",
      linksTitle: "Faydalı Linklər",
      contactTitle: "Əlaqə",
      bookNow: "Vaxt Təyin Et",
      copyright: "Bütün hüquqlar qorunur.",
      brand: "Premium Bərbər · Bakı, Azərbaycan",
    },

    // WhatsApp
    whatsapp: {
      tooltip: "WhatsApp ilə Əlaqə",
      ariaLabel: "WhatsApp ilə əlaqə saxlayın",
    },
  },

  ru: {
    // Navigation
    nav: {
      home: "Главная",
      about: "О нас",
      services: "Услуги",
      gallery: "Галерея",
      reviews: "Отзывы",
      contact: "Контакты",
      menu: "Меню",
      scrollDown: "Прокрутите вниз",
      bookNow: "Записаться",
    },

    // Hero
    hero: {
      caption: "Премиум Барбер · Баку, Азербайджан",
      headline1: "Точность. Стиль.",
      headline2: "Премиум Уход.",
      subheadline: "Орхан Бабаев — точность в каждой стрижке, индивидуальный подход к каждому клиенту.",
      servicesBtn: "Наши Услуги",
      tagline: "Премиум опыт барбера, ощутимый в каждой детали.",
    },

    // About
    about: {
      sectionTitle: "О нас",
      name: "Орхан Бабаев",
      subtitle: "Искусство Барбера",
      description: `Орхан Бабаев — один из ведущих представителей премиум искусства барбера в Баку, применяет индивидуальный подход к каждому клиенту. Точная техника «fade», уважение к классическому стилю и особое внимание к деталям — вот основа его работы. Здесь каждая стрижка — это не просто работа, а произведение искусства.`,
      highlights: [
        { title: "Эксперт по Точному «Fade»", subtitle: "Precision Fade Specialist" },
        { title: "Современные и Классические Стили", subtitle: "Modern & Classic Styles" },
        { title: "Совершенство в Каждой Детали", subtitle: "Excellence in Every Detail" },
      ],
    },

    // Services
    services: {
      sectionTitle: "Услуги",
      headline: "Премиум Услуга для Каждого Стиля",
      bookNow: "Записаться",
      items: [
        {
          name: "Стрижка",
          description: "Классические и современные стрижки",
          price: "40-50 AZN",
        },
        {
          name: "Окрашивание волос",
          description: "Профессиональное окрашивание",
          price: "60-100 AZN",
        },
        {
          name: "Укладка волос",
          description: "Придание формы волосам",
          price: "30-50 AZN",
        },
        {
          name: "Бритье опасным лезвием",
          description: "Традиционное профессиональное бритье",
          price: "35 AZN",
        },
        {
          name: "Коррекция волос машинкой",
          description: "Уточнение краев и линий волос",
          price: "10-15 AZN",
        },
        {
          name: "Коррекция бородой машинкой",
          description: "Профессиональная стрижка и специальный уход за бородой",
          price: "25-35 AZN",
        },
        {
          name: "Маска для лица",
          description: "Специальный уход за кожей лица",
          price: "15-30 AZN",
        },
        {
          name: "Маска из глины",
          description: "Глубоко очищающая глиняная маска",
          price: "15-30 AZN",
        },
        {
          name: "Маникюр",
          description: "Аккуратный уход за ногтями",
          price: "40 AZN",
        },
        {
          name: "Педикюр",
          description: "Профессиональный уход за ногтями на ногах",
          price: "80-100 AZN",
        },
      ],
    },

    // Why Choose
    whyChoose: {
      sectionTitle: "Почему Орхан Бабаев?",
      headline: "Мастерство. Точность. Доверие.",
      features: [
        {
          title: "Точность в Каждой Детали",
          description: "Каждая стрижка измеряется, каждая линия идеально прорисовывается. Ни одна деталь не упускается из виду.",
        },
        {
          title: "Чистый, Современный Стиль",
          description: "Идеальное сочетание классической техники и современных тенденций.",
        },
        {
          title: "Индивидуальный Подход",
          description: "Стрижка, соответствующая структуре лица и личному стилю каждого клиента.",
        },
        {
          title: "Постоянное Качество",
          description: "Один и тот же высокий стандарт при каждом посещении и одно и то же удовлетворение.",
        },
      ],
    },

    // Gallery
    gallery: {
      sectionTitle: "Галерея",
      headline: "Наши работы",
      filters: {
        all: "Все",
        fade: "Fade",
        beard: "Борода",
        classic: "Классика",
        modern: "Модерн",
      },
      altTexts: [
        "Стрижка «Pompadour fade»",
        "Комбинация «fade» и борода",
        "Классическая стрижка",
        "Профессиональный уход за бородой",
        "Точная линия «fade»",
        "Текстурированная стрижка",
        "Современный стиль «pompadour»",
        "Классический стиль с зачесом назад (Slick back)",
        "Чистый профиль «fade»",
        "Орхан Бабаев за работой",
        "Аккуратный переход «fade»",
        "Стрижка в профиль",
      ],
    },

    // Testimonials
    testimonials: {
      sectionTitle: "Отзывы Клиентов",
      headline: "Что Они Говорят?",
      reviews: [
        {
          text: "Это самая чистая стрижка «fade», которую я когда-либо получал. Внимание к деталям невероятно.",
          name: "Rəşad K.",
        },
        {
          text: "Профессионально, внимательно и каждый раз одинаково высокое качество. Я больше не хожу к другому мастеру.",
          name: "Elnur M.",
        },
        {
          text: "Сервис здесь — настоящий премиум опыт. Это больше, чем просто стрижка, это особый подход.",
          name: "Tural N.",
        },
        {
          text: "Уход за бородой отличный — идеальная форма и точная стрижка.",
          name: "Farid H.",
        },
        {
          text: "Лучший барбер, которого я знаю в Баку. Каждый раз ухожу отсюда полностью довольным.",
          name: "Kamran A.",
        },
      ],
    },

    // Contact
    contact: {
      sectionTitle: "Контакты",
      headline: "Записаться",
      note: "Рекомендуется предварительная запись.",
      labels: {
        phone: "Телефон",
        address: "Адрес",
        hours: "Рабочие Часы",
        instagram: "Instagram",
      },
      values: {
        phone: "+994 55 552 50 01",
        address: "Baku Marriott Hotel Boulevard, Khagani Rustamov Street, 4C, Khatai District, Baku 1010, Azerbaijan",
        hours: "Понедельник – Суббота: 10:00 – 20:00",
        instagram: "@orkhan__babayev",
      },
      ctaCard: {
        title: "Премиум Услуга Барбера",
        headline: "Готовы?",
        description: "Пришло время для твоего нового образа. Запишись, чтобы ощутить премиум опыт барбера с Орханом Бабаевым.",
        whatsapp: "WhatsApp Связь",
        phone: "+994 55 552 50 01",
      },
    },

    // Footer
    footer: {
      tagline: "Каждая стрижка — это произведение искусства.",
      linksTitle: "Полезные Ссылки",
      contactTitle: "Контакты",
      bookNow: "Записаться",
      copyright: "Все права защищены.",
      brand: "Премиум Барбер · Баку, Азербайджан",
    },

    // WhatsApp
    whatsapp: {
      tooltip: "WhatsApp Связь",
      ariaLabel: "Связаться через WhatsApp",
    },
  },

  en: {
    // Navigation
    nav: {
      home: "Home",
      about: "About Us",
      services: "Services",
      gallery: "Gallery",
      reviews: "Reviews",
      contact: "Contact",
      menu: "Menu",
      scrollDown: "Scroll down",
      bookNow: "Book Now",
    },

    // Hero
    hero: {
      caption: "Premium Barber · Baku, Azerbaijan",
      headline1: "Precision. Style.",
      headline2: "Premium Care.",
      subheadline: "Orkhan Babayev — precision in every cut, a personalized approach for every client.",
      servicesBtn: "Our Services",
      tagline: "A premium barber experience, felt in every detail.",
    },

    // About
    about: {
      sectionTitle: "About Us",
      name: "Orkhan Babayev",
      subtitle: "The Art of Barbering",
      description: `In Baku, Orkhan Babayev, one of the leading figures in premium barbering art, applies a personalized approach to each client. Precise "fade" technique, respect for classic style, and special attention to detail form the basis of his work. Here, every cut is not just a job, but a work of art.`,
      highlights: [
        { title: "Precise Fade Specialist", subtitle: "Precision Fade Specialist" },
        { title: "Modern & Classic Styles", subtitle: "Modern & Classic Styles" },
        { title: "Excellence in Every Detail", subtitle: "Excellence in Every Detail" },
      ],
    },

    // Services
    services: {
      sectionTitle: "Services",
      headline: "Premium Service for Every Style",
      bookNow: "Book Now",
      items: [
        {
          name: "Haircut",
          description: "Classic and modern haircuts",
          price: "40-50 AZN",
        },
        {
          name: "Hair Coloring",
          description: "Professional hair dyeing",
          price: "60-100 AZN",
        },
        {
          name: "Hair Styling",
          description: "Giving shape to your hair",
          price: "30-50 AZN",
        },
        {
          name: "Straight Razor Shave",
          description: "Traditional professional shave",
          price: "35 AZN",
        },
        {
          name: "Trimmer Hair Correction",
          description: "Refining hair edges and lines",
          price: "10-15 AZN",
        },
        {
          name: "Beard Styling (Trimmer)",
          description: "Professional beard trimming and special care",
          price: "25-35 AZN",
        },
        {
          name: "Face Mask",
          description: "Special facial skin care",
          price: "15-30 AZN",
        },
        {
          name: "Clay Mask",
          description: "Deeply cleansing clay mask",
          price: "15-30 AZN",
        },
        {
          name: "Manicure",
          description: "Neat nail care",
          price: "40 AZN",
        },
        {
          name: "Pedicure",
          description: "Professional toenail care",
          price: "80-100 AZN",
        },
      ],
    },

    // Why Choose
    whyChoose: {
      sectionTitle: "Why Orkhan Babayev?",
      headline: "Craftsmanship. Precision. Trust.",
      features: [
        {
          title: "Precision in Every Detail",
          description: "Every cut is measured, every line is perfectly drawn. No detail goes unnoticed.",
        },
        {
          title: "Clean, Modern Style",
          description: "The perfect blend of classic technique and modern trends.",
        },
        {
          title: "Personalized Approach",
          description: "A cut tailored to each client's facial structure and personal style.",
        },
        {
          title: "Unwavering Quality",
          description: "The same high standard with every visit and the same satisfaction.",
        },
      ],
    },

    // Gallery
    gallery: {
      sectionTitle: "Gallery",
      headline: "Our Work",
      filters: {
        all: "All",
        fade: "Fade",
        beard: "Beard",
        classic: "Classic",
        modern: "Modern",
      },
      altTexts: [
        "Pompadour fade cut",
        "Fade and beard combination",
        "Classic haircut",
        "Professional beard care",
        "Precise fade line",
        "Textured haircut",
        "Modern pompadour style",
        "Slicked-back classic style",
        "Clean fade profile",
        "Orkhan Babayev at work",
        "Neat fade transition",
        "Side profile cut",
      ],
    },

    // Testimonials
    testimonials: {
      sectionTitle: "Customer Reviews",
      headline: "What Do They Say?",
      reviews: [
        {
          text: "This is the cleanest fade cut I've ever had. The attention to detail is incredible.",
          name: "Rəşad K.",
        },
        {
          text: "Professional, attentive, and the same high quality every time. I don't go to another barber anymore.",
          name: "Elnur M.",
        },
        {
          text: "The service here is a true premium experience. It's more than just a haircut—it's a personalized approach.",
          name: "Tural N.",
        },
        {
          text: "Beard care is excellent—perfect shape and precise trimming.",
          name: "Farid H.",
        },
        {
          text: "The best barber I know in Baku. I leave completely satisfied every time.",
          name: "Kamran A.",
        },
      ],
    },

    // Contact
    contact: {
      sectionTitle: "Contact",
      headline: "Book Now",
      note: "Pre-booking recommended.",
      labels: {
        phone: "Phone",
        address: "Address",
        hours: "Working Hours",
        instagram: "Instagram",
      },
      values: {
        phone: "+994 55 552 50 01",
        address: "Baku Marriott Hotel Boulevard, Khagani Rustamov Street, 4C, Khatai District, Baku 1010, Azerbaijan",
        hours: "Monday – Saturday: 10:00 – 20:00",
        instagram: "@orkhan__babayev",
      },
      ctaCard: {
        title: "Premium Barber Service",
        headline: "Ready?",
        description: "It's time for your new look. Book an appointment to experience the premium barber service with Orkhan Babayev.",
        whatsapp: "Contact via WhatsApp",
        phone: "+994 55 552 50 01",
      },
    },

    // Footer
    footer: {
      tagline: "Every cut is a work of art.",
      linksTitle: "Helpful Links",
      contactTitle: "Contact",
      bookNow: "Book Now",
      copyright: "All rights reserved.",
      brand: "Premium Barber · Baku, Azerbaijan",
    },

    // WhatsApp
    whatsapp: {
      tooltip: "Contact via WhatsApp",
      ariaLabel: "Contact via WhatsApp",
    },
  },
};

// Helper hook for language switching
import { useState, useCallback } from 'react';

export const useLanguage = () => {
  const [language, setLanguage] = useState('az');
  
  const t = useCallback(() => translations[language], [language]);
  
  const changeLanguage = useCallback((lang) => {
    if (translations[lang]) {
      setLanguage(lang);
      document.documentElement.lang = lang;
    }
  }, []);

  return { language, t: t(), changeLanguage, translations };
};

export default translations;
